import { Injectable, Inject } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/Rx';  // use this line if you want to be lazy, otherwise:
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';  // debug
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { HandleError, HttpErrorHandler } from 'mds-ui/app/shared/service/http-error-handler.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DateTimeFormatPipe } from 'mds-ui/app/shared/pipes/date-time-format.pipe';
import { Observable } from 'rxjs/Rx';
import { environment } from 'mds-ui/environments/environment';
import { catchError } from 'rxjs/operators';
import { PriestFormationSearchVO, PriestFormationVO, PriestListResponse, FormationNameDeclare } from '../models/priestFormationVO';


@Injectable()
export class PriestFormationService {
    public priestFormationSearchVO: PriestFormationSearchVO;
    public priestFormationVO: PriestFormationVO;
    formationNameDeclare: FormationNameDeclare;
    private handleError: HandleError;
    dtformat = new DateTimeFormatPipe("en-US");
    url: Array<string> = new Array<string>();
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler) {

        this.handleError = httpErrorHandler.createHandleError('PriestFormationService');
    }

    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };

    formationNameInfoInit() { 
        this.formationNameDeclare = new FormationNameDeclare();
    }

    getPriestDetails(priestFormationSearchVO: PriestFormationSearchVO): Observable<PriestListResponse> {
        return this._http.post<any>(environment.getPriestDetailsUrl, priestFormationSearchVO, this.httpOptions).pipe(
            catchError(this.handleError('getPriestDetails()', [])));
    }


    postPriestFormationDetails(priestFormationVO: PriestFormationVO): Observable<PriestListResponse> {
        return this._http.post<any>(environment.postPriestFormationURL, priestFormationVO, this.httpOptions).pipe(
            catchError(this.handleError('getPriestDetails()', [])));
    }

    getPriestFormationById(id: number, userName: string): Observable<PriestListResponse> {
        return this._http.get<any>(
            environment.getPriestFormationByIdURL + id + "?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('getPriestFormationById', []))
            );
    }

    deletePriestFormationId(id: number, userName: string): Observable<PriestListResponse> {
        return this._http.get<any>(
            environment.deletePriestFormationIdUrl + id + "?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('deletePriestFormationId', []))
            );
    }

    getPriestFormationByPersonId(id: number, userName: string): Observable<PriestListResponse> {
        return this._http.get<any>(
            environment.getPriestFormationByPersonIdURL + "?id=" + id + "&userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('getPriestFormationByPersonId', []))
            );
    }

    getUrl(url: string) {
        if (url.toUpperCase().includes("?")) {
            let b = [];
            b = url.split("?");
            return b[0];
        } else {
            return url;
        }
    }


}